<template>
  <v-col cols="12" sm="6" md="4" class="d-flex">
    <v-card class="elevation-1 flex-grow-1">
      <v-toolbar color="white">
        <v-toolbar-title class="text-md-subtitle-1">
          <span>Referral Summary</span>
          <v-btn
            icon="fa-regular fa-circle-info"
            variant="text"
            aria-label="info"
            color="btncolor"
            @click="showToolTip"
          >
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <v-container pa-0 fluid>
        <v-row v-if="loading" align="center" justify="center">
          <v-col class="pt-0">
            <div class="dashboard-widget-progress-container">
              <v-progress-circular
                :size="75"
                :width="8"
                class="my-auto"
                color="primary"
                indeterminate
              />
            </div>
          </v-col>
        </v-row>

        <v-list v-else dense>
          <v-list-item
            class="align-self-center px-0"
            v-for="item in summary"
            :key="item.title"
          >
            <v-row>
              <v-col cols="2" class="pr-0">
                <v-img
                  :src="item.icon"
                  max-height="25"
                  max-width="30"
                  contain
                />
              </v-col>
              <v-col>
                <v-list-item-title
                  v-text="item.title"
                  class="font-weight-light referral-summary-text"
                />
              </v-col>
              <v-col cols class="pl-0">
                <v-list-item-action class="text-right justify-end">
                  <span
                    class="funnel-count text-h6 pr-4 referral-summary-data"
                    >{{ item.perc }}</span
                  >
                </v-list-item-action>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
      </v-container>
    </v-card>
  </v-col>
</template>

<script>
import api from "@/services/api";
import { mapGetters } from "vuex";

export default {
  name: "console-overview-referral-summary",
  components: {},
  props: {
    product: {
      type: String,
      default: "COMBINED",
    },
  },
  watch: {
    product() {
      console.log(`referral summar product change: ${this.product}`);
      this.parseProductData();
    },
  },
  data() {
    return {
      loading: false,
      statData: {},
      summary: [],
      toolTip: null,
      toolTipDialog: false,
    };
  },
  computed: {
    ...mapGetters("user", ["myBrokerage"]),
    ...mapGetters("auth", ["impBrokerage"]),
  },
  methods: {
    parseProductData() {
      switch (this.product) {
        case "PRIMESTREET":
          this.parsePrimestreetData();
          break;

        case "LEAD_GENIUS":
          this.parseLeadGeniusData();
          break;

        case "COMBINED":
          this.parseCombinedData();
          break;
      }
    },
    parsePrimestreetData() {
      let shownHomes =
        this.statData.shownHomes !== undefined &&
        this.statData.shownHomes !== null
          ? this.statData.shownHomes
          : 0;
      let offersMade =
        this.statData.offersMade !== undefined &&
        this.statData.offersMade !== null
          ? this.statData.offersMade
          : 0;
      let underContract =
        this.statData.underContract !== undefined &&
        this.statData.underContract != null
          ? this.statData.underContract
          : 0;
      let closed =
        this.statData.closed !== undefined && this.statData.closed !== null
          ? this.statData.closed
          : 0;
      // let longTermHold =
      //   resp.data.longTermHold !== undefined ? resp.data.longTermHold : 0;
      let activeReferrals =
        this.statData.activeReferrals !== undefined &&
        this.statData.activeReferrals !== null
          ? this.statData.activeReferrals
          : 0;
      let removed =
        this.statData.removed !== undefined && this.statData.removed !== null
          ? this.statData.removed
          : 0;

      this.buildSummaryData(
        activeReferrals,
        closed,
        removed,
        shownHomes,
        offersMade,
        underContract,
      );
    },
    parseLeadGeniusData() {
      let shownHomes =
        this.statData.leadGeniusShownHomes !== undefined &&
        this.statData.leadGeniusShownHomes !== null
          ? this.statData.leadGeniusShownHomes
          : 0;
      let offersMade =
        this.statData.leadGeniusOffersMade !== undefined &&
        this.statData.leadGeniusOffersMade !== null
          ? this.statData.leadGeniusOffersMade
          : 0;
      let underContract =
        this.statData.leadGeniusUnderContract !== undefined &&
        this.statData.leadGeniusUnderContract != null
          ? this.statData.leadGeniusUnderContract
          : 0;
      let closed =
        this.statData.leadGeniusClosed !== undefined &&
        this.statData.leadGeniusClosed !== null
          ? this.statData.leadGeniusClosed
          : 0;
      let activeReferrals =
        this.statData.leadGeniusActiveReferrals !== undefined &&
        this.statData.leadGeniusActiveReferrals !== null
          ? this.statData.leadGeniusActiveReferrals
          : 0;
      let removed =
        this.statData.leadGeniusRemoved !== undefined &&
        this.statData.leadGeniusRemoved !== null
          ? this.statData.leadGeniusRemoved
          : 0;

      this.buildSummaryData(
        activeReferrals,
        closed,
        removed,
        shownHomes,
        offersMade,
        underContract,
      );
    },
    parseCombinedData() {
      let shownHomes = 0;
      if (
        this.statData.shownHomes !== undefined &&
        this.statData.shownHomes !== null
      ) {
        shownHomes += this.statData.shownHomes;
      }
      if (
        this.statData.leadGeniusShownHomes !== undefined &&
        this.statData.leadGeniusShownHomes !== null
      ) {
        shownHomes += this.statData.leadGeniusShownHomes;
      }

      let offersMade = 0;
      if (
        this.statData.offersMade !== undefined &&
        this.statData.offersMade !== null
      ) {
        offersMade += this.statData.offersMade;
      }
      if (
        this.statData.leadGeniusOffersMade !== undefined &&
        this.statData.leadGeniusOffersMade !== null
      ) {
        offersMade += this.statData.leadGeniusOffersMade;
      }

      let underContract = 0;
      if (
        this.statData.underContract !== undefined &&
        this.statData.underContract != null
      ) {
        underContract += this.statData.underContract;
      }
      if (
        this.statData.leadGeniusUnderContract !== undefined &&
        this.statData.leadGeniusUnderContract != null
      ) {
        underContract += this.statData.leadGeniusUnderContract;
      }

      let closed = 0;
      if (this.statData.closed !== undefined && this.statData.closed !== null) {
        closed += this.statData.closed;
      }
      if (
        this.statData.leadGeniusClosed !== undefined &&
        this.statData.leadGeniusClosed !== null
      ) {
        closed += this.statData.leadGeniusClosed;
      }

      let activeReferrals = 0;
      if (
        this.statData.activeReferrals !== undefined &&
        this.statData.activeReferrals !== null
      ) {
        activeReferrals += this.statData.activeReferrals;
      }
      if (
        this.statData.leadGeniusActiveReferrals !== undefined &&
        this.statData.leadGeniusActiveReferrals !== null
      ) {
        activeReferrals += this.statData.leadGeniusActiveReferrals;
      }

      let removed = 0;
      if (
        this.statData.removed !== undefined &&
        this.statData.removed !== null
      ) {
        removed += this.statData.removed;
      }
      if (
        this.statData.leadGeniusRemoved !== undefined &&
        this.statData.leadGeniusRemoved !== null
      ) {
        removed += this.statData.leadGeniusRemoved;
      }

      this.buildSummaryData(
        activeReferrals,
        closed,
        removed,
        shownHomes,
        offersMade,
        underContract,
      );
    },
    buildSummaryData(
      activeReferrals,
      closed,
      removed,
      shownHomes,
      offersMade,
      underContract,
    ) {
      let total = activeReferrals + closed + removed;

      let shownHomesPerc = 0;
      let offersMadePerc = 0;
      let underContractPerc = 0;
      let closedPerc = 0;
      if (total > 0) {
        shownHomesPerc =
          (shownHomes + offersMade + underContract + closed) / total;
        offersMadePerc = (offersMade + underContract + closed) / total;
        underContractPerc = (underContract + closed) / total;
        closedPerc = closed / total;
      }

      this.summary = [];
      //shown homes
      this.summary.push({
        icon: "/images/shown_homes.png",
        title: "Met & Showed Homes",
        perc: this.toPercentage(shownHomesPerc),
      });

      // made offer
      this.summary.push({
        icon: "/images/made_offer.png",
        title: "Made Offer",
        perc: this.toPercentage(offersMadePerc),
      });

      // under contract
      this.summary.push({
        icon: "/images/under_contract.png",
        title: "Under Contract",
        perc: this.toPercentage(underContractPerc),
      });

      // closed
      this.summary.push({
        icon: "/images/closed.png",
        title: "Closed",
        perc: this.toPercentage(closedPerc),
      });
    },
    async loadReferralSummary() {
      this.loading = true;

      let brokerage = this.myBrokerage;
      if (this.impBrokerage !== null) {
        brokerage = this.impBrokerage;
      }

      if (brokerage) {
        try {
          let { data } = await api.brokerage.stats(brokerage);
          this.statData = data;
          this.parseProductData();
          this.loading = false;
        } catch (e) {
          this.loading = false;

          //shown homes
          this.summary.push({
            icon: "/images/shown_homes.png",
            title: "Met & Showed Homes",
            perc: this.toPercentage(0),
          });

          // made offer
          this.summary.push({
            icon: "/images/made_offer.png",
            title: "Made Offer",
            perc: this.toPercentage(0),
          });

          // under contract
          this.summary.push({
            icon: "/images/under_contract.png",
            title: "Under Contract",
            perc: this.toPercentage(0),
          });

          // closed
          this.summary.push({
            icon: "/images/closed.png",
            title: "Closed",
            perc: this.toPercentage(0),
          });
        }
      } else {
        // TODO: Handle no brokerage set
        this.loading = false;
      }
    },
    toPercentage(val) {
      let perc = val * 100;
      // if (perc > 0 && perc < 2) {
      //   return parseFloat(perc).toFixed(2) + "%";
      // }
      return parseFloat(perc).toFixed(2) + "%";
    },
    showToolTip() {
      this.$emit("toolTip", "OverviewReferralSummaryToolTip");
    },
  },
  mounted() {
    this.loadReferralSummary();
  },
};
</script>

<style scoped>
/*See ConsoleOverview for non-scoped classes*/
.referral-summary-text {
  font-size: 14px !important;
}
.referral-summary-data {
  color: black;
}
</style>
